import { useState, useEffect } from "react";
import { subirDatos, bajarDatos } from './syncSupabase';

const MODULOS_ALQOS = [
  { key: "ncs", label: "No Conformidades", icon: "⚠️" },
  { key: "fmea", label: "FMEA", icon: "🔍" },
  { key: "plan_control", label: "Plan de Control", icon: "✅" },
  { key: "acciones", label: "Acciones Correctivas", icon: "🔁" },
  { key: "auditorias", label: "Auditorías", icon: "🔎" },
  { key: "prog_auditorias", label: "Programa Auditorías", icon: "📅" },
  { key: "analisis_causa", label: "Análisis de Causa", icon: "🔬" },
  { key: "capabilidad", label: "Capabilidad / MSA", icon: "📊" },
  { key: "haccp", label: "HACCP", icon: "🧫" },
  { key: "poes", label: "POEs", icon: "📄" },
  { key: "ots", label: "Órdenes de Trabajo", icon: "📋" },
  { key: "documentos", label: "Documentos", icon: "📁" },
  { key: "ingreso_materiales", label: "Ingreso Materiales", icon: "📦" },
  { key: "preprensa", label: "Pre Prensa", icon: "🖨️" },
  { key: "produccion", label: "Producción", icon: "🏗️" },
  { key: "tpm", label: "TPM Mantenimiento", icon: "🔧" },
  { key: "huella_carbono", label: "Huella de Carbono", icon: "🌱" },
  { key: "fsc", label: "FSC Arqueo", icon: "🌿" },
  { key: "sustentabilidad", label: "Sustentabilidad", icon: "🌍" },
  { key: "proveedores", label: "Proveedores", icon: "🤝" },
  { key: "clientes", label: "Clientes", icon: "🤝" },
  { key: "compras", label: "Compras", icon: "🛒" },
  { key: "cotizacion", label: "Cotización", icon: "💰" },
  { key: "ventas", label: "Ventas", icon: "📈" },
  { key: "rrhh", label: "RRHH", icon: "👥" },
  { key: "capacitaciones", label: "Capacitaciones", icon: "🎓" },
  { key: "hs", label: "H&S", icon: "🦺" },
  { key: "ciberseguridad", label: "Ciberseguridad", icon: "🔐" },
  { key: "stock_materiales", label: "Stock Materiales", icon: "📦" },
  { key: "despacho", label: "Despacho", icon: "🚚" },
  { key: "aria", label: "ARIA — IA", icon: "🤖" },
  { key: "dashboard_ca", label: "Dashboard CA", icon: "🏅" },
  { key: "diseno_desarrollo", label: "Diseño y Desarrollo", icon: "✏️" },
  { key: "oficina_tecnica", label: "Oficina Técnica", icon: "📐" },
  { key: "especificaciones_tecnicas", label: "Especificaciones Técnicas", icon: "📌" },
  { key: "usuarios", label: "Usuarios", icon: "👥" },
  { key: "importar_csv", label: "Importar CSV", icon: "📥" },
  { key: "assured_quality", label: "Assured Quality", icon: "🏆" },
  { key: "trazabilidad", label: "Trazabilidad", icon: "🔗" },
  { key: "costos_no_calidad", label: "Costos de No Calidad", icon: "💸" },
  { key: "cumplimiento_normas", label: "Cumplimiento de Normas", icon: "📋" },
  { key: "comunicados", label: "Comunicados Internos", icon: "📢" },
  { key: "onboarding", label: "Onboarding", icon: "🚀" },
  { key: "escritorio_calidad", label: "Escritorio Calidad", icon: "🗂️" },
  { key: "consultor_hs", label: "Portal Asesores", icon: "🔍" },
  { key: "centros_costo", label: "Centros de Costo", icon: "⚙️" },
  { key: "motor_costeo", label: "Motor de Costeo", icon: "🧮" },
];

const STORAGE_KEY = 'alqos_mapa_procesos';
const storage = {
  get: () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; } },
  set: (v) => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch {} },
};

export default function MapaProcesos({ onVolver, oscuro, usuario }) {
  const [mapas, setMapas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [vista, setVista] = useState("listado");
  const [moduloActivo, setModuloActivo] = useState(null);
  const [form, setForm] = useState({});
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    async function cargar() {
      const ok = await bajarDatos(STORAGE_KEY);
      if (ok) setMapas(storage.get());
      else setMapas(storage.get());
      setCargando(false);
    }
    cargar();
  }, []);

  const esAdmin = usuario?.rol === "Administrador";
  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const card = { background: cardBg, borderRadius: "12px", padding: "1.5rem", border: `1px solid ${borde}`, marginBottom: "12px" };
  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };

  if (cargando) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: bg }}>
      <p style={{ color: oscuro ? "white" : "#09184D", fontSize: "16px" }}>Cargando mapa de procesos...</p>
    </div>
  );

  const guardar = () => {
    const existe = mapas.find(m => m.modulo_key === form.modulo_key);
    let nuevos;
    if (existe) {
      nuevos = mapas.map(m => m.modulo_key === form.modulo_key ? {
        ...m, ...form,
        ultima_edicion: new Date().toISOString(),
        editado_por: usuario?.nombre,
      } : m);
    } else {
      const nuevo = {
        ...form,
        id: Math.floor(Date.now() + Math.random() * 1000),
        creado_por: usuario?.nombre,
        fecha_creacion: new Date().toISOString(),
      };
      nuevos = [...mapas, nuevo];
    }
    setMapas(nuevos);
    storage.set(nuevos);
    subirDatos(STORAGE_KEY);
    setVista("listado");
    setForm({});
    setModuloActivo(null);
  };

  const abrirEditor = (moduloKey) => {
    const existente = mapas.find(m => m.modulo_key === moduloKey);
    const modulo = MODULOS_ALQOS.find(m => m.key === moduloKey);
    setModuloActivo(modulo);
    setForm(existente || {
      modulo_key: moduloKey,
      entradas: [],
      salidas: [],
      logica_adicional: "",
    });
    setVista("editor");
  };

  const toggleModuloEnLista = (campo, key) => {
    setForm(f => {
      const lista = f[campo] || [];
      const yaEsta = lista.includes(key);
      return { ...f, [campo]: yaEsta ? lista.filter(k => k !== key) : [...lista, key] };
    });
  };

  const SelectorModulos = ({ campo, excluirKey }) => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "8px" }}>
      {MODULOS_ALQOS.filter(m => m.key !== excluirKey).map(m => {
        const activo = (form[campo] || []).includes(m.key);
        return (
          <button
            key={m.key}
            type="button"
            onClick={() => toggleModuloEnLista(campo, m.key)}
            style={{
              padding: "5px 10px",
              borderRadius: "8px",
              fontSize: "11px",
              fontWeight: "600",
              cursor: "pointer",
              border: activo ? "2px solid #7B5BF2" : `1px solid ${borde}`,
              background: activo ? "rgba(123,91,242,.12)" : cardBg,
              color: activo ? "#7B5BF2" : subtexto,
              display: "inline-flex",
              alignItems: "center",
              gap: "4px"
            }}>
            <span>{m.icon}</span>{m.label}
          </button>
        );
      })}
    </div>
  );

  const Header = ({ titulo, onBack }) => (
    <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", gap: "12px", position: "sticky", top: 0, zIndex: 100, marginBottom: "1.5rem" }}>
      <button onClick={onBack} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Volver</button>
      <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
    </div>
  );

  // ── EDITOR ──
  if (vista === "editor") return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo={`🗺️ ${moduloActivo?.icon} ${moduloActivo?.label}`} onBack={() => { setVista("listado"); setForm({}); }} />
      <div style={{ padding: "0 1.5rem 2rem", maxWidth: "700px", margin: "0 auto" }}>

        <div style={card}>
          <p style={{ fontSize: "13px", fontWeight: "700", color: "#2A7FFF", margin: "0 0 4px" }}>⬅️ Entradas</p>
          <p style={{ fontSize: "11px", color: subtexto, margin: "0 0 4px" }}>¿De qué módulos recibe datos {moduloActivo?.label}?</p>
          <SelectorModulos campo="entradas" excluirKey={moduloActivo?.key} />
        </div>

        <div style={card}>
          <p style={{ fontSize: "13px", fontWeight: "700", color: "#22c55e", margin: "0 0 4px" }}>➡️ Salidas</p>
          <p style={{ fontSize: "11px", color: subtexto, margin: "0 0 4px" }}>¿A qué módulos les pasa datos o dispara acciones {moduloActivo?.label}?</p>
          <SelectorModulos campo="salidas" excluirKey={moduloActivo?.key} />
        </div>

        <div style={card}>
          <p style={{ fontSize: "13px", fontWeight: "700", color: texto, margin: "0 0 4px" }}>📝 Lógica / disparadores adicionales</p>
          <p style={{ fontSize: "11px", color: subtexto, margin: "0 0 4px" }}>Para casos puntuales que no son solo "conecta con X" — ej: "Auditoría con hallazgo crítico → genera NC automática"</p>
          <textarea
            rows={5}
            value={form.logica_adicional || ""}
            onChange={e => setForm(f => ({ ...f, logica_adicional: e.target.value }))}
            placeholder="Describí la lógica o el disparador puntual..."
            style={{ ...inp, resize: "vertical" }}
          />
        </div>

        <button onClick={guardar}
          style={{ width: "100%", padding: "14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: "pointer" }}>
          Guardar mapa de proceso
        </button>
      </div>
    </div>
  );

  // ── LISTADO ──
  const modulosFiltrados = MODULOS_ALQOS.filter(m => m.label.toLowerCase().includes(busqueda.toLowerCase()));
  const documentados = mapas.filter(m => (m.entradas?.length || m.salidas?.length || m.logica_adicional)).length;

  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>🗺️ Mapa de Procesos ALQOS™</span>
        </div>
        <span style={{ fontSize: "12px", color: "rgba(255,255,255,.6)" }}>{documentados}/{MODULOS_ALQOS.length} documentados</span>
      </div>

      <div style={{ padding: "1.5rem" }}>
        <input
          placeholder="🔍 Buscar módulo..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          style={{ ...inp, marginBottom: "1rem" }}
        />

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "10px" }}>
          {modulosFiltrados.map(modulo => {
            const mapa = mapas.find(m => m.modulo_key === modulo.key);
            const tieneContenido = mapa && (mapa.entradas?.length || mapa.salidas?.length || mapa.logica_adicional);
            return (
              <div key={modulo.key}
                onClick={() => esAdmin && abrirEditor(modulo.key)}
                style={{ background: cardBg, borderRadius: "12px", padding: "1rem", border: `1.5px solid ${tieneContenido ? "#22c55e40" : borde}`, cursor: esAdmin ? "pointer" : "default", transition: "box-shadow .2s" }}
                onMouseEnter={e => { if(esAdmin) e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"; }}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
                  <span style={{ fontSize: "20px" }}>{modulo.icon}</span>
                  {tieneContenido
                    ? <span style={{ fontSize: "10px", background: "#f0fdf4", color: "#22c55e", border: "1px solid #86efac", borderRadius: "6px", padding: "2px 6px", fontWeight: "600" }}>✓ Documentado</span>
                    : <span style={{ fontSize: "10px", background: oscuro ? "#1e3a8a" : "#f5f3ff", color: subtexto, border: `1px solid ${borde}`, borderRadius: "6px", padding: "2px 6px" }}>Pendiente</span>
                  }
                </div>
                <p style={{ fontSize: "12px", fontWeight: "600", color: texto, margin: "0 0 2px" }}>{modulo.label}</p>
                {tieneContenido && (
                  <p style={{ fontSize: "10px", color: subtexto, margin: 0 }}>
                    {mapa.entradas?.length || 0} entradas · {mapa.salidas?.length || 0} salidas
                  </p>
                )}
                {!tieneContenido && esAdmin && <p style={{ fontSize: "10px", color: "#7B5BF2", margin: 0 }}>+ Documentar conexiones</p>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
